import { Box, FormControl, MenuItem, Select, type SelectChangeEvent } from '@mui/material';
import { SUPPORTED_LOCALES, type Locale } from '@rendimees24/i18n';
import { useTranslation } from 'react-i18next';

import { useAuth } from '../auth/AuthContext';
import { writeChosenLocale, type AppLocale } from '../lib/accountLocale';


const LABELS: Record<Locale, string> = {
  et: 'Eesti',
  en: 'English',
  ru: 'Русский',
  fi: 'Suomi',
};

export function LanguageSwitcherMui() {
  const { user } = useAuth();
  const { t, i18n } = useTranslation('admin');
  const current = (i18n.resolvedLanguage ?? 'et') as Locale;

  const handle = (e: SelectChangeEvent) => {
    const lng = e.target.value as Locale;
    void i18n.changeLanguage(lng);
    // Per-user, so a shared site phone does not hand this choice to whoever
    // signs in next; writeCachedLocale keeps the shared key in step for the
    // pre-auth boot.
    writeChosenLocale(user?.uid ?? null, lng as AppLocale);
    // <html lang> is set by syncDocumentLang (main.tsx) on languageChanged.
  };

  return (
    <FormControl size="small" variant="outlined" sx={{ minWidth: { xs: 70, sm: 120 }, flexShrink: 0 }}>
      <Select
        value={current}
        renderValue={(value) => <>
          <Box component="span" sx={{ display: { xs: 'inline', sm: 'none' } }}>{value.toUpperCase()}</Box>
          <Box component="span" sx={{ display: { xs: 'none', sm: 'inline' } }}>{LABELS[value as Locale]}</Box>
        </>}
        onChange={handle}
        inputProps={{ 'aria-label': t('admin:languageSwitcher.ariaLabel') }}
        sx={{ bgcolor: 'background.paper' }}
      >
        {SUPPORTED_LOCALES.map((lng) => (
          <MenuItem key={lng} value={lng}>
            {LABELS[lng]}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
